import { type DocumentDetailsVersion, type IdAndTitle } from "~/api/types";
import InviteReadersModal from "~/organisms/InviteReadersModal";
import { ReadersOverview } from "~/organisms/ReadersOverview";
import { QuizManagementSection } from "~/organisms/anchoring/QuizManagementSection";
import { canInviteReaders } from "~/helpers/documentPermissions";
import { canManageQuizzes } from "~/helpers/quizPermissions";
import { useUserContext } from "~/hooks/useUserContext";
import { Separator } from "~/atoms/separator";

interface Props {
  documentVersion: DocumentDetailsVersion;
  category: IdAndTitle;
}

export const ReadersOverviewTab = ({ documentVersion, category }: Props) => {
  const { user } = useUserContext();
  const isInviteAllowed = canInviteReaders(documentVersion);
  const canManageQuiz = canManageQuizzes(user.role);

  return (
    <div className="grid gap-6">
      <div className="grid gap-4">
        {isInviteAllowed && (
          <InviteReadersModal
            documentVersionId={documentVersion.id}
            category={category}
          />
        )}

        <ReadersOverview
          documentVersionId={documentVersion.id}
          isRemoveAllowed={isInviteAllowed}
        />
      </div>

      {canManageQuiz && (
        <>
          <Separator />
          <QuizManagementSection
            documentVersion={documentVersion}
            category={category}
          />
        </>
      )}
    </div>
  );
};
